import { useCallback, useState } from "react";
import { UploadSimple, FileArrowUp } from "@phosphor-icons/react";

/**
 * Reusable drag-and-drop zone.
 * Props:
 *   accept: string (e.g. "image/*" or ".csv")
 *   label: string
 *   sublabel: string
 *   onFile: (file) => void
 *   testId
 */
export default function Dropzone({ accept = "*", label = "Drop files here", sublabel = "", onFile, testId = "dropzone", multiple = false, icon: Icon = FileArrowUp }) {
  const [drag, setDrag] = useState(false);

  const onDrop = useCallback((e) => {
    e.preventDefault(); e.stopPropagation();
    setDrag(false);
    const files = Array.from(e.dataTransfer?.files || []);
    if (!files.length) return;
    if (multiple) files.forEach(f => onFile(f));
    else onFile(files[0]);
  }, [onFile, multiple, setDrag]);

  const onPick = (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    if (multiple) files.forEach(f => onFile(f));
    else onFile(files[0]);
    e.target.value = "";
  };

  return (
    <label
      onDragEnter={(e) => { e.preventDefault(); setDrag(true); }}
      onDragOver={(e) => { e.preventDefault(); setDrag(true); }}
      onDragLeave={() => setDrag(false)}
      onDrop={onDrop}
      data-testid={testId}
      className={`block cursor-pointer rounded-2xl border-2 border-dashed transition-all duration-200 p-8 sm:p-10 text-center
        ${drag ? "border-[#FFB020] bg-[#FFB020]/10 scale-[1.01]" : "border-white/15 bg-white/[0.02] hover:border-white/30 hover:bg-white/[0.04]"}`}
    >
      <input type="file" accept={accept} multiple={multiple} hidden onChange={onPick} data-testid={`${testId}-input`} />
      <div className={`mx-auto w-14 h-14 rounded-full flex items-center justify-center mb-4 transition-colors ${drag ? "bg-[#FFB020] text-[#050B0A]" : "bg-white/5 text-[#FFB020]"}`}>
        <Icon size={26} weight="duotone" />
      </div>
      <div className="font-display text-lg">{label}</div>
      {sublabel && <div className="text-white/50 text-xs mt-2">{sublabel}</div>}
      <div className="mt-5 inline-flex items-center gap-2 text-xs text-white/60">
        <UploadSimple size={14} /> or click to browse
      </div>
    </label>
  );
}
